module.exports = __webpack_public_path__ + "static/media/sign.f521da34.png";